import { Tooltip } from 'antd';
import { BaseButton } from 'components/button/button-base';
import { useBillingPermissions } from '../hooks/use-billing-permissions';
import { paths } from 'routes';

interface TopUpBalanceButtonProps {
  hasPaymentMethod: boolean;
  pathname: string;
}

export function TopUpBalanceButton(props: TopUpBalanceButtonProps) {
  const permissions = useBillingPermissions();

  if (permissions.isLoading || !permissions.shouldShowTopUpButton) {
    return null;
  }

  return (
    <Tooltip
      title={
        !props.hasPaymentMethod && 'Disabled until a payment method is set'
      }
      showArrow
    >
      <BaseButton
        type="dashed"
        disabled={!props.hasPaymentMethod}
        href={paths.clinician.billing.buy.bulk(props.pathname)}
      >
        Click here to top up your balance
      </BaseButton>
    </Tooltip>
  );
}
